import { FC, useContext } from 'react';
import { Avatar, Box, ListItemButton, ListItemIcon, ListItemText, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import NavItem from './NavItem';
import { useNavigate } from 'react-router-dom';
import { NavContext } from '../../../context/NavContext';
import NavDrawer from './NavDrawer';
import useAuth from '../../../hooks/useAuth';

interface NavProps { }

const Nav: FC<NavProps> = () => {
  const { user, userAuthorizedRoutes } = useAuth();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'));
  const navigate = useNavigate();
  const navContextData = useContext(NavContext);

  return (
    <Box id="Nav" component="nav" sx={{ zIndex: 1301, fontFamily: "Montserrat-Variable" }}>
      <NavDrawer>
        <Stack sx={{ marginBottom: 'auto' }}>
          <Stack
            sx={{
              width: "100%",
              [theme.breakpoints.down('tablet')]: {
                marginTop: '12px'
              },
            }}
            direction="row"
            justifyContent="center">
          </Stack>
          {userAuthorizedRoutes.map((route, index) => (
            route.sidebarProps ? (
              <NavItem key={index} item={route} />
            ) : null
          ))}
        </Stack>
        <Stack
          id="DealerProfileNavLink"
          justifyContent='center'>
          <ListItemButton
            selected={navContextData?.currentRoute?.state === 'dealer-profile'}
            sx={{
              paddingLeft: '12px',
              "&.Mui-selected": {
                backgroundImage: "linear-gradient(to right, #931216, #E20B23, #FF8230)",
                color: "white"
              },
              "&.Mui-selected:hover": {
                backgroundImage: "linear-gradient(to right, #931216, #E20B23, #FF8230)",
                color: "white"
              },
              "&.Mui-focusVisible": {
                backgroundImage: "linear-gradient(to right, #931216, #E20B23, #FF8230)",
                color: "white"
              },
            }}
            onClick={() => {
              if (navContextData?.navExpanded && isTablet) { navContextData.setNavExpanded(false); }
              navigate('./dealer-profile')
            }}>
            <ListItemIcon sx={{ marginRight: '8px' }}>
              <Avatar src={user?.companyAttributes?.logo} />
            </ListItemIcon>
            <ListItemText>
              <Typography variant='nav'>Dealer Profile</Typography>
            </ListItemText>
          </ListItemButton>
        </Stack>
      </NavDrawer>
    </Box>
  )
};

export default Nav;

